export const num = (v: unknown): number => (typeof v === 'number' ? Math.round(v) : 0);

export const OTHER_JS_RESOURCE_TYPE: any = 'other';

export const IMAGE_RESOURCE_LABEL: any = '<image-resource>';

export const FILE_RESOURCE_LABEL: any = '<file-resource>';

export const AVATAR_RESOURCE_LABEL: any = '<avatar-resource>';
